import ContractNew from './ContractNew.vue';

export default ContractNew;
